import appendChildren from '../../../general/append/appendChildren';

import * as exOption from '../../option';

// ----------------------------------------------------------------------------

function addOptions(element: HTMLSelectElement, config: Record<string, any> = {}): void {
    // Create elements (option)
    const listOption = exOption.create(config);

    // Append children
    appendChildren(element, listOption);
}

// ----------------------------------------------------------------------------

export default addOptions;
